export default __webpack_public_path__ + "static/media/create-post.a753a193.svg";